module.exports = __webpack_public_path__ + "media/courses/curricula/images/level-up-e1a7e73698e7e6dc8f18a78188de3f5f.svg";